import { AppUpdateRequestModal as BaseAppUpdateRequestModal } from '@dvb/ui';
import { getMinimumVersionOptions } from '@school-manage/api/actions/system/system.options';
import { useQuery } from '@tanstack/react-query';
import { compare } from 'compare-versions';
import { useMemo } from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

export function AppUpdateRequestModal() {
  const { data: minimumVersion } = useQuery(getMinimumVersionOptions());
  const {
    /**
     * 'updatefound' event will emit immediately after finding new service worker
     * And 'hasUpdate' variable only change when all assets are cached
     */
    needRefresh: [hasUpdate],
    updateServiceWorker,
  } = useRegisterSW();

  const isForceUpdate = useMemo(() => {
    if (!minimumVersion) return false;
    try {
      return compare(APP_VERSION, minimumVersion, '<');
    } catch (error) {
      return false;
    }
  }, [minimumVersion]);

  return (
    <BaseAppUpdateRequestModal
      hasUpdate={hasUpdate}
      isForceUpdate={isForceUpdate}
      updateServiceWorker={updateServiceWorker}
    />
  );
}
